<template>
<div class="container-fluid_">
<div class="card border border-primary">
  <div class="card-header bg-primary text-white">
    <h4><i style="color:yellow" class="fas fa-info-circle mr-2" aria-hidden="true"></i>INFO VENDITE</h4>
  </div>
  <div class="card-body">
    <div v-if="spinner" class="text-center">
        <div style="width: 3rem; height: 3rem;" class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div v-else>

<div v-if="items.length==0">
  <h4  class="text-center" style="color:red"> <strong>VENDITE NON PRESENTI.</strong> </h4>
</div>    

<div v-else>
<div class="table-wrapper-scroll-y my-custom-scrollbar">    
<table class="table border border-secondary_ rounded ">
<thead >
      <tr>
          <th class="text-left">SEDE</th>

          <th class="text-left">DATA</th>
          <th class="text-left">PROVENIENZA</th>
          <th class="text-left">CLIENTE</th>
          <th scope="col">TIPO</th>
          <th><i  class="fas fa-user-tag" aria-hidden="true"></i></th>
          <th class="text-left">EAN</th>
          <th class="text-left">PRODOTTO</th>
          <th class="text-left">COLORE</th>
          <th class="text-left">MISURA</th>
      
          <th class="text-right" scope="col">IMPORTO</th>
          <th class="text-right" scope="col">SCONTO</th>
          <th class="text-right" scope="col">TOTALE</th>
          <th class="text-right text-nowrap" scope="col">ABBUONO DI CASSA %</th>
          <th class="text-right text-nowrap" scope="col">VAL. RESO</th>
          
          <th class="text-right" scope="col">PAGATO</th>
          <th class="text-right text-nowrap" scope="col">TIPO PAGAMENTO</th>
          <th></th>
                    
      </tr>
      </thead>
      <tbody>
      <tr :style="{backgroundColor: item.row_type==2 ? '#FFFFE0':'white', color: item.row_type==2  ? 'blue' : 'black',fontSize: item.row_type == 2 ? '16px':'16px',fontWeight:item.row_type == 2 ? 'bold':'normal' }" v-for="(item, index) in items" :key="index">
      <td class="text-left"> 

          {{item.store}}    
              
          </td>
          
          <td class="text-left" >
          
          {{item.create_at}} 
          <span v-if="item.hour_at">{{item.hour_at.substr(0,5)}}</span>
          
          
          </td>
          <td class="text-left" :style="{color:item.sold_by == 'Retail' ? 'black':'#f66c09',fontWeight:item.sold_by == 'Retail' ? 'normal':'bold'}">{{item.sold_by}}</td>
          <td class="text-nowrap text-left" :style="{color:item.sold_by == 'Retail' ? 'black':'#3bab05',fontWeight:item.sold_by == 'Retail' ? 'normal':'bold'}">{{item.customer}}</td>
          <td class="text-nowrap" >
          
          <span v-if="item.row_type == 1" style="color:red" id="reso" class="form-text ">R</span>
          <span v-if="item.row_type == 0" style="color:black" id="vendita" class="form-text ">V</span>

          </td>
          <td><strong>{{item.assistant_code}} </strong></td>
          <td class="text-left">
              
              <span style="font-size: large;" v-if="match(item.barcode)" class="badge badge-success">{{item.barcode}}</span>

              <span v-else>{{item.barcode}}</span>
              
              </td>
          <td  class="text-nowrap text-left">{{item.brand}} {{item.category}} </td>
          
          <td class="text-left">{{item.color}}</td>
          <td class="text-left">{{item.size}}</td>
      
          <td class="text-right">
            {{fmt1(item.price)}}</td>
          <td class="text-right">{{item.discount}}</td>
          <td :style="{color:item.row_type == 1 ? 'red':'black'}" class="text-right">
            <span>
              <button data-toggle="tooltip" title="Applica come valore di reso." v-if="item.barcode == barcode" @click="$emit('close',item.row_total,item.saleId)"  class="btn btn-light">               
              <i style="font-size: 22px;" class="fas fa-edit" aria-hidden="true"></i>              
            </button>
            </span>            
            {{fmt1(item.row_total)}}</td>
          <td class="text-right">{{fmt1(item.row_total_discount)}}</td>
          <!--<td class="text-right">{{fmt(item.row_return_percent)}} % -->  
          <td class="text-right">
            <span>
              <button data-toggle="tooltip" title="Applica come valore di reso." v-if="item.barcode == barcode && item.row_return_total > 0" @click="$emit('close',item.row_return_total,item.saleId)"  class="btn btn-light">               
              <i style="font-size: 22px;" class="fas fa-edit" aria-hidden="true"></i>              
            </button>
            </span>
            <span>{{fmt1(item.row_return_total)}}</span>
            
          </td>
         
          <td class="text-right">
          <i v-if="item.row_type == 2 && item.round_total > 0 " style='color:red;font-size: 12px;'  class="mr-2" aria-hidden="true">
              <span>
              (+{{

                item.round_total

              }})
              </span>
          </i>
                    
          <span v-if="item.row_type == 2">{{fmt1(item.total_paid)}}</span>
          
          </td>
          <td class="text-right">{{item.payment_type}}</td>
          <td> <i v-if="item.printTicket==1" class="fas fa-print" aria-hidden="true"></i></td>
          
      </tr> 
      </tbody>
      
  </table>
  

</div>
</div>
</div>



        
  </div>

  
</div>

</div>
</template>
<script>
import alertBox           from '@/components/common/AlertBox.vue';


import api                from '@/api'
import { mapGetters }     from 'vuex';
import fmt               from '@/components/mixins/fmt'

export default {
  mixins     : [fmt],
  props      : ['barcode'],
  components : {alertBox},
  data() {
    return {
     
     
      spinner             : false,
     
      msg                    : {
        title                : '',
        body                 : '',
        type                 : 0
      }, 
      items                  : [],
     
      
      
    };
  },
  computed :{
   
    ...mapGetters(['company']) , 
   
    total : function() {
   
      let  total = {
        total1 : 0,total2:0,total3:0
      }
      this.items.forEach(item => {
        if(item.row_type==2)
        {
          total.total1 += Number(item.row_total)
          total.total2 += Number(item.total_discount)
          total.total3 += Number(item.total_paid)

        }
      })
      return total
    }


  },
  
  mounted: function() {
     
    this.spinner = true
  },
  created: function() {
      
      //console.log('BARCODE ---> '  ,this.barcode)
      this.getData()

  },
  methods: {
   match(barcode1)
   {
    
    if(barcode1 == this.barcode)
    {
      return true
    }
   },
   row_total_discount(item)
   {
       if(item.row_count == item.row_number)
       {
           return item.total_discount
       }
       else
       {
           return item.row_total_discount
       }
   },
   formatList()
    {
        var arr = []
        
        var total = 0
        let total_return = 0
        var rowIndex = 0
        
        for (var i = 0; i < this.items.length; i++)   
          {
            var m = 1
            if(this.items[i]['row_type'] == 1)
            {
              m = -1
            }
            total += Number(this.items[i]['row_total']) * m
            total_return += Number(this.items[i]['row_return_total']) * m
            arr.push(this.items[i])    

            if(this.items[i]['row_number'] == this.items[i]['row_count'])
              {
                rowIndex++

               /*             
                arr.push({'index': rowIndex, 'row_type':2,'row_total':total,'row_total_discount':this.items[i]['total_discount'],'total_paid':this.items[i]['total_paid'],'printTicket':this.items[i]['printTicket'],'payment_type':this.items[i]['payment_type']
                ,'round_total':this.items[i]['round_total']
                */
                arr.push({'index': rowIndex, 'row_type':2,'row_total':total,
                'row_return_total' : total_return ,
                'total_paid':this.items[i]['total_paid'],'printTicket':this.items[i]['printTicket'],'payment_type':this.items[i]['payment_type']
                ,'round_total':this.items[i]['round_total']

                })
                total = 0
                total_return = 0
                
                
              }
           
            
          }

         
          arr.forEach(item=>{
            if(item.row_type != 2)
            {
              item.total_discount = 0.00
              item.total_paid     = 0.00
              item.printTicket   = 0
              item.payment_type   = ''
              // Scarto 1° riga Scontrino per Data e Ora
              if(item.row_number > 1 )
              {
                item.create_at = ''
                item.hour_at = ''
              }
              
            }
          })
          this.items = arr
          

    },
   
    async getData() {
      
      this.spinner = true
      this.msg.title = '' 
      this.items = []
      
      const sp    = {'sp':'spProductAllSalesNew'}
     
      const data  = {'companyId':this.company.Id,'barcode':this.barcode}
      const json  = Object.assign(data, sp)

      //this.bt_spinner = true
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.items    = res.data.recordsets[0]
        
            if(this.items.length ==0 )
            {
              
              this.msg.title = "ATTENZIONE "
              this.msg.body = 'DATI INESISTENTI.'
              this.msg.type = 1
     
            }
            else
            {
              this.formatList()
              this.spinner = false

              /*
              this.$nextTick()
               .then(function () {
                $('#staticBackdrop10').modal('show')
        
                })
                */
              
            }
         
          }
          else if(res.status==500)
          {
            console.log(res.data)   
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res.data
            this.msg.type  = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1                  
            

          } 
      }).catch(err => 
      {
      console.log(err)    
      this.msg.title = 'ATTENZIONE '
      this.msg.body  = err.message
      this.msg.type  = 1  

      }).finally(() => {
        this.spinner = false
      });

    },

  }
};
</script>
<style scoped>
.card-header{
  height : 45px;
}
.my-custom-scrollbar {
  position: relative;
  height: 800px;
  overflow: auto;
}


.table-wrapper-scroll-y {
  display: block;
}

.pointer:hover
{

  cursor: pointer;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    
    
    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 

h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}
.date_time
{
  font-size: 10px;
}

</style>